/** Auth routes where third-party trackers must not load (CCPA / cookie controls). */
export const TRACKING_DISABLED_AUTH_PATHS = [
  '/login',
  '/forgot',
  '/sign-up',
] as const

export function normalizePathname(pathname: string): string {
  const trimmed = pathname.trim()
  if (!trimmed || trimmed === '/') {
    return '/'
  }
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed
}

export function isTrackingDisabledOnPath(pathname: string): boolean {
  return (TRACKING_DISABLED_AUTH_PATHS as readonly string[]).includes(
    normalizePathname(pathname)
  )
}

export function isTrackingDisabledOnCurrentPath(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  return isTrackingDisabledOnPath(window.location.pathname)
}
